export default class Postleitzahl {
    /** PK: PLZ | max. 4 Zeichen | erforderlich **/
    public plz: string | null = null;
    /** Ort | max. 60 Zeichen **/
    public ort: string | null = null;
    /** Bundesland | max. 2 Zeichen **/
    public bundesland: string | null = null;

    constructor(data?: Partial<Postleitzahl>) {
        Object.assign(this, data);
    }
}
